export function setupViewportFix() {
  const setAppHeight = () => {
    const doc = document.documentElement;
    const vh = window.innerHeight * 0.01;

    // Set both CSS custom properties
    doc.style.setProperty("--vh", `${vh}px`);
    doc.style.setProperty("--app-height", `${window.innerHeight}px`);
  };

  // Set initial height
  setAppHeight();

  // Update height on resize, orientation change, and scroll
  window.addEventListener("resize", setAppHeight);
  window.addEventListener("orientationchange", setAppHeight);
  window.addEventListener("scroll", setAppHeight);

  // Additional event for Chrome mobile toolbar
  window.addEventListener("visibilitychange", setAppHeight);
}
